import axios from "axios";

export default axios.create({
     baseURL: "https://qa-service.asraimmigration.ca/backend_service/v1/"
    // baseURL: "http://localhost:9000/backend_service/v1/"
});
